import {useCallback} from 'react'
import {gql, useMutation} from '@apollo/client'

export default (onSuccess, onError) => {
  const [mutation, {data, error, loading}] = useMutation(
    gql`
      mutation(
        $files: [Upload!]!
        $taskId: ID!
        $stepId: ID!
        $phase: PhaseEnum!
        $planId: ID!
      ) {
        uploadFilesToTask(
          files: $files
          taskId: $taskId
          stepId: $stepId
          phase: $phase
          planId: $planId
        )
      }
    `,
  )
  const submit = useCallback(
    (obj) => {
      mutation({variables: obj})
        .then((result) => {
          onSuccess(result)
        })
        .catch((e) => {
          onError(e)
        })
    },
    [mutation, onSuccess, onError],
  )
  return {loading, data: data ? data.uploadFilesToTask : null, error, submit}
}
